// import { hover } from '@testing-library/user-event/dist/hover';
import React from 'react';
import { BsTwitter, BsInstagram } from 'react-icons/bs';
import { FaFacebookF } from 'react-icons/fa';

const SocialMedia = () => {
  return (
    <div className='app__social'>
      <div>
        <BsTwitter />
      </div>

      <div>
        <a
          href='https://www.facebook.com/adil.ahamed.9461/'
          target='_blank'
          rel='noreferrer'
        >
          <FaFacebookF />
        </a>
      </div>

      <div>
        <a
          href='https://www.instagram.com/rock_ster_adil/'
          target='_blank'
          rel='noreferrer'
        >
          <BsInstagram href='https://www.instagram.com/rock_ster_adil/' />
        </a>
      </div>
    </div>
  );
};

export default SocialMedia;
